(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["description"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shop-description')) {
    customElements.define('shop-description', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup) return;
        const button = this.querySelector('.description-toggle');
        const body = this.querySelector('.description-body');
        if (!button || !body) return;
        const mobile = window.matchMedia('(max-width: 749px)');
        let expanded = false;
        const render = () => {
          const open = !mobile.matches || expanded;
          body.hidden = !open;
          button.hidden = !mobile.matches;
          button.setAttribute('aria-expanded', String(open));
          button.textContent = open ? 'Prikaži manje' : 'Saznajte više';
        };
        const toggle = () => { expanded = !expanded; render(); };
        button.addEventListener('click', toggle);
        mobile.addEventListener('change', render);
        this.cleanup = () => {
          button.removeEventListener('click', toggle);
          mobile.removeEventListener('change', render);
        };
        render();
      }
      disconnectedCallback() {
        if (this.cleanup) this.cleanup();
        this.cleanup = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
